import { Divider, Form, Input } from 'antd';
import type { PropsWithChildren } from 'react';

import { requiredRule } from 'app/utils/rules';

import { HeaderWrapper } from '../../../../HeaderWrapper/HeaderWrapper';

import './ActionContainer.scss';

type Props = {
  fieldName: string | number;
};

export const ActionContainer = ({
  children,
  fieldName,
}: PropsWithChildren<Props>) => {
  return (
    <div className="actionContainer">
      <div className="arrow"></div>
      <HeaderWrapper title="Style" gapTitleChildren={16}>
        <div className="commonForm">
          <HeaderWrapper isBold={false} title="Name">
            <Form.Item name={[fieldName, 'label']} rules={[requiredRule]}>
              <Input placeholder="ex. Expériences avec piscine" />
            </Form.Item>
          </HeaderWrapper>
        </div>
      </HeaderWrapper>

      <Divider />
      {children}
    </div>
  );
};
